import { Button } from "@/components/button";
import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Center, Flex, Text } from "@chakra-ui/react";
import { type StoreBoxProps } from "./storeBox.type";

export const StoreBox = ({ store, idx, setPosition }: StoreBoxProps) => {
    const { place_name: placeName, category_group_name: categoryName, address_name: addressName, id } = store;
    const { COLORS, FONTS } = useDesignMaxTheme();

    const handleNavigate = (key: string) => {
        if (key === "detail") {
            window.location.href = `https://place.map.kakao.com/${id}`;
        }

        if (key === "guide") {
            window.location.href = `https://map.kakao.com/link/to/${id}`;
        }
    };

    return (
        <Center
            w="100%"
            pb="16px"
            cursor="pointer"
            borderBottom="1px solid"
            borderColor={COLORS.gray[300]}
            _last={{ borderBottom: "none" }}
            onClick={() => setPosition({ lat: parseFloat(store.y), lng: parseFloat(store.x) })}
        >
            <Flex w="100%" flexDir="column" gap="8px">
                <Flex w="100%" flexDir="column">
                    <Flex gap="8px" alignItems="flex-end">
                        <Text color={COLORS.gray[500]} sx={{ ...FONT("pretendard", 16, 500) }}>
                            {idx + 1}.
                        </Text>
                        <Text color={COLORS.gray[500]} sx={{ ...FONT("pretendard", 16, 500) }}>
                            {placeName}
                        </Text>
                        <Text as="span" color={COLORS.gray[500]} sx={{ ...FONT("pretendard", 14, 300) }}>
                            {categoryName}
                        </Text>
                    </Flex>
                    <Text color={COLORS.gray[500]} sx={{ ...FONT("pretendard", 14, 300) }}>
                        {addressName}
                    </Text>
                </Flex>
                <Flex
                    gap="4px"
                    sx={{
                        "& > button": {
                            w: "72px",
                            p: "12px 0",
                            ...FONTS.pre.n3,
                        },
                    }}
                >
                    <Button size="tiny" border="none" onClick={() => handleNavigate("guide")}>
                        <Text as="span" className="material-icons" fontSize="20px">
                            reply
                        </Text>
                        <Text>길찾기</Text>
                    </Button>
                    <Button size="tiny" border="none" onClick={() => handleNavigate("detail")}>
                        <Text>상세 보기</Text>
                    </Button>
                </Flex>
            </Flex>
        </Center>
    );
};
